import { useTranslation } from "react-i18next";

import PersonalSourcesTab from "@/pages/ask-sources/components/PersonalSourcesTab";
import OpsMateRouteShell from "@/pages/opsmate/components/OpsMateRouteShell";

function PersonalSourceInOpsMateInner() {
  const { i18n } = useTranslation();
  const isZh = i18n.language === "zh";

  return (
    <OpsMateRouteShell>
      <div className="flex min-h-full flex-col bg-gray-50/60 rounded-xl">
        <div className="bg-white px-6 py-4 border-b border-gray-100">
          <h1 className="text-xl font-bold text-gray-900">Personal Source</h1>
          <p className="text-sm text-gray-500 mt-0.5">
            {isZh
              ? "管理仅自己可见的个人文件并查看 AI 知识库同步状态"
              : "Manage your private files and view their AI knowledge base sync status"}
          </p>
        </div>

        <div className="bg-white">
          <PersonalSourcesTab isZh={isZh} />
        </div>
      </div>
    </OpsMateRouteShell>
  );
}

export default function PersonalSourcePage() {
  return <PersonalSourceInOpsMateInner />;
}
